import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.currency('Real Estate / Mortgage Balance - Homestead', 'liabilityRealEstateMortgageHomestead', false, 6),
      helper.currency('Real Estate / Mortgage Balance - Investments', 'liabilityRealEstateMortgageInvestments', false, 6),
      helper.currency('Accounts & Notes Payable - Business', 'liabilityAccountsNotesPayableBusiness', false, 6),
      helper.currency('Accounts & Notes Payable - Other', 'liabilityAccountsNotesPayableOther', false, 6),
      helper.currency('Unpaid Taxes', 'liabilityUnpaidTaxes', false, 6),
      helper.currency('Credit Card Debt', 'liabilityCreditCardDebt', false, 6),
      helper.currency('Other Liabilities', 'liabilityOther', false, 6),
      helper.currency('Installment Accounts - Auto', 'liabilityInstallmentAuto', false, 6),
      helper.currency('Installment Accounts - Other', 'liabilityInstallmentOther', false, 6),
      helper.currency('Life Insurance Loans', 'liabilityLifeInsuranceLoan', false, 6),
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/schemaLiabilities.js